import axios from 'axios'
import { Auth } from '../utils/auth'
import store from '../../store'
import _ from 'lodash'

const http = axios.create({
  baseURL: _.isEmpty(Auth.getBackendUrl()) ? process.env.API_URL : Auth.getBackendUrl(),
  // baseURL: window.localStorage.getItem('backend_url') !== undefined ? window.localStorage.getItem('backend_url') : process.env.API_URL,
  // baseURL: `http://127.0.0.1:9006/`,
  timeout: 100000,
  headers: {
    // Authorization: 'Bearer {token}'
  }
})


http.interceptors.request.use(config => {
  if (Auth.getToken()) {
    config.headers['Authorization'] = 'Bearer ' + Auth.getToken()
  }
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status === 403) {
      if (typeof error.response.data === 'string' ||
          error.response.data instanceof String) {
        if (error.response.data.includes('User not logged')) {
          Auth.goLogin()
        }
      } else if ('message' in error.response.data) {
        if (error.response.data.message.includes('User not logged')) {
          Auth.goLogin()
        }
      }
    }
    /* Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    }) */
    return Promise.reject(error)
  },
)

export default http


// WEBPACK FOOTER //
// ./src/core/network/http.js